import React from 'react';
import Input from '../../components/shared/inputs/input';
import Button from '../../components/shared/button';
import TabStrip, { Tab } from '../../components/TabStrip';
import Popups from './popups';

import ListViewDemo from './listView';
import ContentSlide from './contentSlide';

export const SimpleContent: React.FC = () => {
  return (
    <>
      <ListViewDemo />
    </>
  );
};

export const TabsContent: React.FC = () => {
 // const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  return (
    <>
      {/* <div>
        <div className="nav_strip classic">
          <ul>
            <li //NOSONAR
              className={classNames({ selected: selectedTabIndex === 0 })}
              onClick={() => {
                setSelectedTabIndex(0);
              }}
            >
              <separator data-vertical="" data-height="20"></separator>
              <group
                data-align="center"
                data-space="10"
                data-gap="10"
                data-wrap="no"
              >
                <text>Buttons Icons</text>
              </group>
            </li>
            <li //NOSONAR
              className={classNames({ selected: selectedTabIndex === 1 })}
              onClick={() => {
                setSelectedTabIndex(1);
              }}
            >
              <separator data-vertical="" data-height="20"></separator>
              <group
                data-align="center"
                data-space="10"
                data-gap="10"
                data-wrap="no"
              >
                <text>Buttons Icons</text>
              </group>
            </li>
          </ul>
        </div>
      </div> */}

      <TabStrip
        onChange={(index) => {
          console.log(index);
        }}
        skipSecondaryTabs={false}
        selectedIndex={0}
        //  id="myTabStrip"
        invert={false}
      >
        <Tab title="First Tab">
          <view>
            <view data-scroll="">
              <group data-space="20" data-direction="column">
                <text
                  light="" //NOSONAR
                  data-wrap="wrap"
                  data-length="400"
                >
                  Quisque commodo ut urna et dignissim. In vitae dui fermentum
                  odio luctus efficitur in non mauris. Nulla tristique ac nisi
                  nec auctor.
                </text>
                <icon></icon>
                <Input
                  name="asd"
                  labelPosition="left"
                  icon="search"
                  size="large"
                  //  label="Large Input component"
                  button={
                    <>
                      <separator
                        data-vertical=""
                        data-height="input"
                      ></separator>

                      <Button large text="Search Here"></Button>
                    </>
                  }
                />
              </group>
              <ContentSlide></ContentSlide>
            </view>
            <group data-space="15" data-align="center" data-wrap="no">
              <Button large primary>
                <text>Sample Action</text>
              </Button>
              <text data-space="10" data-ellipsis="">
                This Toolbar is Part of content
              </text>
            </group>
          </view>
        </Tab>
        <Tab title="Second Tab">
          <Popups />
        </Tab>
      </TabStrip>
    </>
  );
};
